import { Route, Routes } from 'react-router-dom'
import Layout from '../../Layout/Layout'
import { MMPClientRoutes } from './MMPClientRoutes'

export default function LayoutRoutes() {
    return (
        <>
            <Routes>
                {MMPClientRoutes.map(({ path, element }, i) => (
                    <Route element={<Layout />} key={i}>
                        <Route path={path} element={element} />
                    </Route>
                ))}
                
            </Routes>
        </>
    )
}